import { render, staticRenderFns } from "./SubMenuEdit.vue?vue&type=template&id=55cbba5a&scoped=true"
import script from "./SubMenuEdit.vue?vue&type=script&lang=js"
export * from "./SubMenuEdit.vue?vue&type=script&lang=js"
import style0 from "./SubMenuEdit.vue?vue&type=style&index=0&id=55cbba5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cbba5a",
  null
  
)

export default component.exports